// import Feedback from './Feedback/Feedback'
import time_icon from './img/time_icon.svg'
import view_icon from './img/view_icon.svg'
import { ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { MoonLoader } from 'react-spinners'
import { useNavigate } from 'react-router-dom';
import ListOfContent from '../ArticleTypesComponent/ListOfContent/ListOfContent';
import { useState, useEffect, useId } from 'react'
import { ShortTileArticleBox } from "@lk-gtcom/ecomlab-components";
import { TextareaAutosize } from '@mui/material'
import TitleContentEditable from '../../../components/Modal/ModalAddTask2/test/TitleContentEditable';
import { RavshanHttps } from '../../../fetchUrls';
import headers from '../../../common/headers';
import { useDebounce } from '../../../hooks/useDebounce';
import { SelectedBlocks } from '../ArticleTypesComponent/SelectedBlocks/SelectedBlocks';
import './ArticleViewV2.scss'
import { ButtonWithIcon } from '../../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import { usePushNotifications } from '../../../common/pushNotification';
import { ModalSettingsView } from '../ModalSettingsView/ModalSettingsView';
import { Tooltip } from '../../../components/TooltipV2/Tooltip';

// Иконки
import copy_icon from './img/copy.svg'
import trash_icon from './img/trash_icon.svg'
import viewing_icon from './img/viewing.svg'
import no_viewing_icon from './img/no_viewing.svg'

const ArticleViewV2 = ({
    loading,
    readonly = true,
    apiData,
    contentData,
    setContentData,
    publishEventSource,
    isNew,
    articleTitle,
    showTitle = true,
    setArticleTitle,
    articleTitleRef,
    setContentChanged,
    hideInfoPanel = false,
    articleId,
    title,
    setTitle,
    description,
    setDescription,
    pathBread,
    hiddenSeo = false,
    modalStyle = false,
    listLinks,
    setListLinks,
    fetchDataById,
    deleteArticle,
    isEditor
}) => {
    // Обработка ошибок
    const { addErrorPush, addSuccessPush } = usePushNotifications();

    const [isModalView, setIsModalView] = useState(false)

    const [newElementId, setNewElementId] = useState(-1)
    const [newElementPostition, setNewElementPosition] = useState()
    const id = useId()
    const [changeId, setChangeId] = useState(id)
    const [activeLang, setActiveLang] = useState(() => localStorage.getItem('lang') ?? 'ru')
    const [isDropShare, setIsDropShare] = useState(false)
    const [isChangeTypeModal, setIsChangeTypeModal] = useState(false)
    const [isViewMode, setIsViewMode] = useState(false)
    const [listPreview, setListPreview] = useState([])
    const [isFavorite, setIsFavorite] = useState(false)
    const [isPin, setIsPin] = useState(false)
    const navigate = useNavigate()
    const componentRefs = []

    const onSetTitle = (value) => {
        const url = `${RavshanHttps}/api/v2/article/set_name`
        const body = JSON.stringify({
            article_id: articleId,
            name: value
        })

        fetch(url, { body, method: 'POST', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(json => {

            })
            .catch(err => {
                console.error(err);

            })
    }
    const debounceTitle = useDebounce(onSetTitle, 1000)

    const setSeoTitle = (value) => {
        const url = `${RavshanHttps}/api/v2/article/set_title`
        const body = JSON.stringify({
            article_id: articleId,
            title: value
        })

        fetch(url, { body, method: 'POST', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(json => {

            })
            .catch(err => {
                console.error(err);

            })
    }
    const debounceSeoTitle = useDebounce(setSeoTitle, 1000)

    // Закрепить статью
    const fetchPinArticle = (pin) => {
        const url = ` https://portals.ecomru.ru/api/v2/article/pin`

        const body = JSON.stringify({
            article_id: articleId,
            pin: pin
        })

        fetch(url, { body, method: 'POST', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(json => {

            })
            .catch(err => {
                console.error(err);

            })
    }

    // Добавить в избранное статью
    const fetchFavoriteArticle = (favorite) => {
        const url = ` https://portals.ecomru.ru/api/v2/article/favorite`

        const body = JSON.stringify({
            article_id: articleId,
            favorite: favorite
        })

        fetch(url, { body, method: 'POST', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(json => { })
            .catch(err => {
                console.error(err);

            })
    }

    const setSeoDesctiption = (value) => {
        const url = `${RavshanHttps}/api/v2/article/set_description`
        const body = JSON.stringify({
            article_id: articleId,
            description: value
        })

        fetch(url, { body, method: 'POST', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(json => {

            })
            .catch(err => {
                console.error(err);

            })
    }
    const debounceSeoDesctiption = useDebounce(setSeoDesctiption, 1000)

    const getSavedArray = () => {
        const result = []
        componentRefs.forEach(element => {
            result.push({
                type: element.type,
                data: element.getData(),
                id: element.id,
                align: element.getAlign(),
                fontSize: element.getSize()
            })
        })
        return result
    }

    const translateAuthor = () => {
        if (activeLang == 'ru') return 'Неизвестный автор'
        if (activeLang == 'tr') return 'Bilinmeyen Yazar'
        if (activeLang == 'en') return 'Unknown_author'
    }

    const translateMin = () => {
        if (activeLang == 'en') return 'min'
        if (activeLang == 'tr') return 'dak'
        return 'мин'
    }

    const translateNoViews = () => {
        if (activeLang == 'en') return '0'
        // 'Нет просмотров' 
        if (activeLang == 'tr') return '0'
        // 'Görüntüleme yok'
        return '-'
        // 'Нет просмотров'
    }

    const translateRecommendations = () => {
        if (activeLang == 'en') return 'This is going to be interesting'
        if (activeLang == 'tr') return ' Ilginiz çeker'
        return 'Будет интересно'
    }


    // подписываемся на click event кнопки, по которой вызывается паблишинг, чтобы на момент срабатывания в родительском компоненте были свежие данные
    useEffect(() => {
        function updateContent() {
            setContentData(getSavedArray())
        }

        if (publishEventSource) {
            publishEventSource.addEventListener('click', updateContent)
        }

        return () => {
            if (publishEventSource) {
                publishEventSource.removeEventListener('click', updateContent)
            }
        }
    }, [changeId, contentData])

    useEffect(() => {
        const isDrop = (e) => {
            let el = e.target
            if (!el.closest(`#share`)) {
                setIsDropShare(false)
            }
        }
        document.addEventListener('click', isDrop)

        return () => {
            document.addEventListener('click', isDrop)
        }
    }, [])

    // Получение превью статей (блок с рекомендациями)
    const fetchGetPreview = (article_id) => {
        const url = ` https://portals.ecomru.ru/api/v2/article/preview/${article_id}`

        fetch(url, { method: 'GET', headers })
            .then(async res => {
                if (res.ok) {
                    return res.json()
                } else {
                    const err = await res.json()
                    throw new Error(JSON.stringify(err))
                }
            })
            .then(json => {
                setListPreview(json)
            })
            .catch(err => console.error(err))
    }

    useEffect(() => {
        fetchGetPreview(articleId)
    }, [articleId]);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    const user_name = localStorage.getItem('client_name')
    const user_email = localStorage.getItem('email')
    const curr_author = user_name ? user_name : user_email

    return (
        <div className='article-view'>

            {isModalView && <ModalSettingsView
                isModalView={isModalView}
                setIsModal={setIsModalView}
            />}

            {!hideInfoPanel && <div className='article-view__btn-panel'>

                <Tooltip
                    child={
                        <ButtonWithIcon
                            size='m'
                            pin
                            whiteGreen
                            changeValue={isPin}
                            onClick={(e) => {
                                fetchPinArticle(!isPin)
                                setIsPin(!isPin)
                            }}
                        />
                    }
                    text={!isPin ? 'Закрепить' : 'Убрать из закрепленных'}
                />

                <Tooltip
                    child={
                        <ButtonWithIcon
                            size='m'
                            favorite
                            whiteGreen
                            changeValue={isFavorite}
                            onClick={(e) => {
                                fetchFavoriteArticle(!isFavorite)
                                setIsFavorite(!isFavorite)
                            }}
                        />
                    }
                    text={!isFavorite ? 'Добавить в избранное' : 'Убрать из избранного'}
                />


                {(isEditor) && <>
                    <Tooltip
                        child={
                            <ButtonWithIcon
                                size='m'
                                icon={copy_icon}
                                whiteGreen
                                onClick={(e) => {
                                    navigator.clipboard.writeText('/article' + apiData?.cpu)
                                    addSuccessPush(`Скопировано ${'/article' + apiData?.cpu}`)
                                }}
                            />
                        }
                        text={'Копировать id статьи'}
                    />

                    <Tooltip
                        child={
                            <ButtonWithIcon
                                size='m'
                                green
                                icon={isViewMode ? no_viewing_icon : viewing_icon}
                                onClick={(e) => setIsViewMode(!isViewMode)}
                            />
                        }
                        text={isViewMode ? 'Режим редактирования' : 'Режим просмотра'}
                    />

                    <Tooltip
                        child={
                            <ButtonWithIcon
                                red
                                size='m'
                                icon={trash_icon}
                                onClick={(e) => {
                                    deleteArticle(articleId)
                                }}
                            />
                        }
                        text={'Удалить статью'}
                    />
                </>}
            </div>}

            {/* {isModalSocial && <ModalSelectionSocialMedia setIsModal={(e) => setIsModalSocial(e)} />} */}
            <section className={`article-view__content 
                ${!readonly ? 'article-view__content_edit' : ''}
                ${modalStyle ? 'article-view__content-modal' : ''}`}>
                <div className='article'>
                    {
                        loading
                            ?
                            <div className="article-loader" >
                                <MoonLoader
                                    color="#7b7b7b"
                                    speedMultiplier={0.5}
                                />
                            </div>
                            :
                            <>
                                {(!hideInfoPanel) && <div className='article-view__info-article'>

                                    {/*Дата создания*/}
                                    <div className='article-view__date-box'>
                                        {/* <img src={calendar_icon.src} /> */}
                                        <p className='article-view__text-grey'>
                                            {isNew ? new Date()?.toLocaleDateString('ru-ru') :
                                                (apiData?.date
                                                    ?
                                                    new Date(apiData?.date)?.toLocaleDateString('ru-ru')
                                                    :
                                                    'Неизвестная дата')}
                                        </p>
                                    </div>

                                    {/*Просмотры*/}
                                    <div className='article-view__view-box'>
                                        <img src={view_icon} />
                                        <p className='article-view__text-grey'>
                                            {apiData?.views ? apiData?.views : translateNoViews()}
                                        </p>
                                    </div>

                                    {/*Время чтения*/}
                                    <div className='article-view__time-box'>
                                        <img src={time_icon} />
                                        <p className='article-view__text-grey'>
                                            {`${apiData?.reading_time_min ? apiData?.reading_time_min : '0'} ${translateMin()}`}
                                        </p>
                                    </div>

                                    {/*Автор*/}
                                    <div className='article-view__share-and-author'>

                                        {isNew ?
                                            <p className='article-view__author-element'>
                                                <div className='article-view__author-avatar'
                                                    style={{ backgroundColor: '#F79E6C' }}
                                                >{curr_author?.split(' ')
                                                    .map(str => str[0])
                                                    .reduce((acc, current) => acc += current, '')?.toUpperCase() || '-'}
                                                </div>
                                                <p className='article-view__text-grey article-view__text-grey_author'>
                                                    {curr_author}
                                                </p>
                                            </p>
                                            :
                                            <p className='article-view__author-element'>
                                                <p className='article-view__text-grey article-view__text-grey_author'>
                                                    {apiData?.author?.[0] ? apiData?.author?.[0] : translateAuthor()}
                                                </p>
                                                <div className='article-view__author-avatar'
                                                    style={{
                                                        backgroundColor: (Array.isArray(apiData?.author) && apiData?.author?.length > 1)
                                                            ?
                                                            apiData?.author[1]
                                                            :
                                                            ''
                                                    }}

                                                >{(Array.isArray(apiData?.author) && apiData?.author?.length > 0) > 0 ?
                                                    apiData?.author[0]?.split(' ')
                                                        .map(str => str[0])
                                                        .reduce((acc, current) => acc += current, '')?.toUpperCase() : '-'}
                                                </div>
                                            </p>
                                        }

                                        {/* <ShareComponent
                                            hideText
                                            activeLang={activeLang}
                                            id={articleId}
                                            articlePath={articlePath}
                                        /> */}
                                    </div>
                                </div>

                                }

                                {(!isNew && (isViewMode || readonly || !isEditor)) &&
                                    showTitle ?
                                    <div className='title-box'>
                                        < h1 className='title__big'>{articleTitle || 'Нет названия заголовка'}</h1>
                                    </div>
                                    :
                                    null}

                                {((!isViewMode && !readonly && isEditor) || isNew) &&
                                    <div className='title-box'>
                                        <TextareaAutosize
                                            type='text'
                                            ref={articleTitleRef}
                                            placeholder='Введите заголовок'
                                            className='title__big title-input'
                                            value={articleTitle}
                                            onChange={e => {
                                                debounceTitle(e.target.value)
                                                setContentChanged(true)
                                                setArticleTitle(e.target.value)
                                            }}
                                            autoFocus={true}
                                        />

                                        <div className='btn-group'>
                                            <button onClick={() => setArticleTitle("")} className='edit-article-wrapper__close'></button>
                                        </div>
                                    </div>
                                }

                                {(!hiddenSeo && (!readonly || isNew)) && <>
                                    <div className='article__input-group'>
                                        <TitleContentEditable
                                            titleStatic='Title'
                                            placeholder='Введите title для статьи (70 символов)'
                                            requared={true}
                                            title={title}
                                            setTitle={value => {
                                                debounceSeoTitle(value)
                                                if (typeof setTitle === 'function') {
                                                    setTitle(value)
                                                }
                                            }}
                                            maxlength={70}
                                        />

                                        <TitleContentEditable
                                            titleStatic='Description'
                                            requared={true}
                                            placeholder='Введите description для статьи (140 символов)'
                                            title={description}
                                            setTitle={(value) => {
                                                debounceSeoDesctiption(value)
                                                if (typeof setDescription === 'function') {
                                                    setDescription(value)
                                                }
                                            }}
                                            maxlength={140}
                                        />
                                    </div>
                                </>
                                }

                                <ListOfContent
                                    readonly
                                    links={listLinks}
                                    lang={activeLang}
                                />

                                <SelectedBlocks
                                    readonly={isViewMode || readonly || !isEditor}
                                    apiData={apiData}
                                    articleId={articleId}
                                    setListLinks={setListLinks}
                                    fetchDataById={fetchDataById}
                                    setIsModalView={setIsModalView}
                                />

                                {/* {contentComponents} */}
                            </>
                    }

                    {/* {
                        !readonly
                        &&
                        <div className='btn-box'>
                            {noContent && <button className='btn__round-blue' onClick={(e) => setShowAddBlockPopup(true)} />}
                        </div>
                    } */}

                    {/* <Feedback /> */}
                </div>
            </section >

            {
                listPreview?.length > 0
                    ?
                    <div className='article-view__this-will-be-interesting'>
                        <h2 className='article-view__this-will-be-interesting-title'>{translateRecommendations()}</h2>
                        <div className='article-view__this-will-be-interesting-content'

                        >
                            {
                                listPreview?.map(el => {
                                    return <ShortTileArticleBox
                                        {...el}
                                        id={el.id}
                                        name={el?.cpu?.[0]}
                                        cpu={el?.cpu?.[1]}
                                        views={el?.clicks}
                                        timeToRead={el?.reading_time_min}
                                        photoPreview={el?.photo}
                                        // date={new Date(el?.date)}
                                        activeLang={activeLang}
                                        fromArticle={true}
                                        wiki={true}
                                        pathArticles='/ru'
                                        pathBread={pathBread}
                                        stopRedirect={false}
                                        onLinkClick={() => {
                                            const path = ('/wiki/ru' + el?.cpu?.[1])
                                            navigate(path)
                                            window.location.reload()
                                        }}
                                    />
                                    // </div>
                                })
                            }
                        </div>
                    </div>
                    : null
            }
        </div >
    )
}

export default ArticleViewV2